import { Component, Input, OnInit } from '@angular/core';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { CalculationResult, Warnings } from '../../models/calculationModels';

@Component({
    selector: 'app-warning-output',
    templateUrl: './warning-output.component.html',
    styleUrls: ['./warning-output.component.scss'],
    standalone: false,
})
export class WarningOutputComponent implements OnInit {
    @Input()
    set calcOutput(value: CalculationResult) {
        if (value !== undefined && value?.output !== null) {
            this._calcOutput = value;
            this.loadErrorWarningNotes();
        }
    }
    get calcOutput(): CalculationResult {
        return this._calcOutput;
    }

    warnings: Warnings[] = [];
    errors: Warnings[] = [];
    notes: Warnings[] = [];
    isWarningShown: boolean = true;
    private _calcOutput: CalculationResult;
    constructor(private globalEmittersService: GlobalEmittersService) {}

    ngOnInit(): void {
        this.warnings = [];
        this.errors = [];
        this.notes = [];

        this.loadErrorWarningNotes();

        this.globalEmittersService.selectedTools.subscribe((res) => {
            if (res != null) {
                this.warnings = this.warnings.filter((w) => !w.tool_id);
                if (this.calcOutput?.output?.tools) {
                    const warning = this.calcOutput?.output?.tools.find((t) => t.id === res)?.warnings;
                    if (warning?.length) {
                        this.warnings?.push(
                            ...warning?.map((resp) => {
                                resp.tool_id = res;
                                return resp;
                            })
                        );
                    }
                }
            }
        });

        this.globalEmittersService.refreshWarnings.subscribe((res) => {
            if (res === true) {
                this.warnings = [];
                this.errors = [];
                this.notes = [];
            }
        });
    }

    hideWarings() {
        this.isWarningShown = !this.isWarningShown;
    }

    loadErrorWarningNotes() {
        if (this.calcOutput !== undefined && this.calcOutput?.output !== null) {
            this.errors = [];
            this.warnings = [];
            this.notes = [];
            for (var i = 0; i < this.calcOutput?.output?.general?.warnings.length; i++) {
                if (this.calcOutput?.output?.general?.warnings[i].type === 1) {
                    this.errors.push(this.calcOutput?.output?.general?.warnings[i]);
                } else if (this.calcOutput?.output?.general?.warnings[i].type === 2) {
                    this.warnings.push(this.calcOutput?.output?.general?.warnings[i]);
                } else if (this.calcOutput?.output?.general?.warnings[i].type === 3) {
                    this.notes.push(this.calcOutput?.output?.general?.warnings[i]);
                }
            }
            if (this.calcOutput?.output?.tools) {
                const selectedtools = this.calcOutput?.output?.tools.filter((x) => x.isSelected == true);
                if (selectedtools?.length) {
                    for (var i = 0; i < selectedtools[0].warnings.length; i++) {
                        if (selectedtools[0]?.warnings[i]?.type === 1) {
                            this.errors.push(selectedtools[0]?.warnings[i]);
                        } else if (selectedtools[0]?.warnings[i]?.type === 2) {
                            this.warnings.push(selectedtools[0]?.warnings[i]);
                        } else if (selectedtools[0]?.warnings[i]?.type === 3) {
                            this.notes.push(selectedtools[0]?.warnings[i]);
                        }
                    }
                }
            }
        }
    }
}
